import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputText } from "primereact/inputtext";
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';
import config from '../../config';
import { Col, Row, Card, } from 'react-bootstrap';
import { getSocket } from '../../context/socket'; // adjust path as needed
import moment from 'moment-timezone';
import { Tooltip } from 'primereact/tooltip';
const Add_task = ({ boardId, listId, onClose }) => {
    const { accessToken, userId } = useAuth();
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [dueDate, setDueDate] = useState(null);
    const [dueDateOnly, setDueDateOnly] = useState(null); // Just the date
    const [dueTimeOnly, setDueTimeOnly] = useState('20:00'); // Default to 8:00 PM
    const [reminderDate, setReminderDate] = useState(null);
    const [priority, setPriority] = useState('Low');
    const [taskType, setTaskType] = useState('Normal');
    const [members, setMembers] = useState([]);
    const [selectedMembers, setSelectedMembers] = useState([]);
    const [loading, setLoading] = useState(false);

    const socket = getSocket();

    const priorities = ['Low', 'Medium', 'High', 'Urgent'];
    const taskTypes = ['Normal', 'Post', 'Meeting'];

    const [formData, setFormData] = useState({
        date: '',
        meeting_type: 'Internal',
        meeting_title: '',
        meeting_members: '',
        agenda: '',
        decisions: '',
        action_items: '',
        discussions: '',
        client_updates: '',
        post_title: '',
        color: "#FF0000",
    });


    const meetingTypes = [
        { label: 'Call', value: 'Call' },
        { label: 'Video Call', value: 'Video_call' },
        { label: 'In Person', value: 'In_person' },
        { label: 'Hybrid', value: 'Hybrid' },
        { label: 'Internal', value: 'Internal' },
        { label: 'Client Meeting', value: 'Client_meeting' },
        { label: 'Presentation', value: 'Presentation' },
        { label: 'Review', value: 'Review' },
        { label: 'Training', value: 'Training' },
        { label: 'Brainstorming', value: 'Brainstorming' }
    ];

    const colors = [
        { color: "#FF0000", name: "Red" },
        { color: "#0000FF", name: "Blue" },
        { color: "#FFD700", name: "Gold" },
        { color: "#50C878", name: "Emerald" },
        { color: "#7851A9", name: "Purple" },
        { color: "#40E0D0", name: "Turquoise" },
        { color: "#FF7F50", name: "Coral" },
        { color: "#FF00FF", name: "Magenta" },
        { color: "#000080", name: "Navy" },
        { color: "#DC143C", name: "Crimson" },
        { color: "#228B22", name: "Forest Green" },
        { color: "#008080", name: "Teal" },
        { color: "#87CEEB", name: "Sky Blue" },
        { color: "#FF66CC", name: "Pink" },
        { color: "#7FFF00", name: "Chartreuse" },
        { color: "#FFBF00", name: "Amber" },
        { color: "#708090", name: "Slate Gray" },
        { color: "#32CD32", name: "Lime Green" },
        { color: "#191970", name: "Midnight Blue" },
        { color: "#FF69B4", name: "Hot Pink" },
        { color: "#800000", name: "Maroon" },
        { color: "#2E8B57", name: "Sea Green" },
        { color: "#DDA0DD", name: "Plum" },
        { color: "#808000", name: "Olive" },
        { color: "#B87333", name: "Copper" },
    ];

    useEffect(() => {
        if (dueDateOnly) {
            const [hours, minutes] = dueTimeOnly.split(':');
            const merged = new Date(dueDateOnly);
            merged.setHours(parseInt(hours), parseInt(minutes), 0, 0);
            setDueDate(merged);
        }
    }, [dueDateOnly, dueTimeOnly]);

    // Fetch all users and brands
    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const { data } = await axios.get(
                    `${config.apiBASEURL}/projectRoutes/fetch-all-users`,
                    {
                        headers: { Authorization: `Bearer ${accessToken}` },
                    }
                );
                setMembers(data);
            } catch (error) {
                console.error("Error fetching users:", error);
            }
        };

        fetchUsers();
    }, [accessToken]);


    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };



    const handleSubmit = () => {
        setLoading(true);

        // Set due date to midnight IST (00:00:00)
        const dueDateIST = dueDate
            ? moment(dueDate).subtract(5, 'hours').subtract(30, 'minutes').format("YYYY-MM-DD HH:mm:ss")
            : null;

        const reminderDateIST = reminderDate
            ? moment(reminderDate).startOf('day').subtract(5, 'hours').subtract(30, 'minutes').format("YYYY-MM-DD HH:mm:ss")
            : null;

        const cardPayload = {
            title,
            description,
            due_date: dueDateIST,
            reminder_date: reminderDateIST,
            priority,
            task_type: taskType,
            position: 0
        };


        // ✅ Use .toLocaleDateString("en-CA") for formData.date to ensure YYYY-MM-DD format
        const formDateIST = formData.date
            ? new Date(formData.date).toLocaleDateString("en-CA") + ' 00:00:00'
            : null;

        const finalFormData = {
            ...formData,
            date: formDateIST // 👈 Ensure date is in YYYY-MM-DD 00:00:00
        };

        socket.emit("addCard", {
            board_id: boardId,
            list_id: listId,
            userId,
            cardData: cardPayload,
            formdata: finalFormData,
            members: selectedMembers
        });

        // optionally listen for confirmation
        socket.once("cardAdded", (response) => {
            // optional: toast notification or state update
            onClose();
            setLoading(false);
        });

        socket.once("cardError", (error) => {
            console.error("Socket error adding card:", error.message);
            setLoading(false);
        });
    };

    return (
        <Row className="mx-0">
            {/*---Right_part--- */}
            <Col lg={12} md={12} sm={12} className="p-0 right_partD">
                <Card className="shadow-0 p-0">
                    <Card.Header className="px-0 border-0">
                        <h5>Add Task</h5>
                    </Card.Header>
                    <Card.Body className="px-0 pt-0">
                        <Row>
                            <Col md={12} lg={12} className="px-2 mb-3">
                                <label>Task Name</label>
                                <InputText
                                    placeholder="Task Title"
                                    value={title}
                                    onChange={(e) => setTitle(e.target.value)}
                                    className="w-100"
                                />
                            </Col>
                            <Col md={12} lg={12} className="px-2 mb-1">
                                <label>Description</label>
                                <InputTextarea
                                    autoResize
                                    placeholder="Description"
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                    className="w-100 mb-3 h-auto"
                                    rows={5}
                                />
                            </Col>
                            <Col md={12} lg={12} className="px-2 mb-3">
                                <label>Task Type</label>
                                <Dropdown
                                    value={taskType}
                                    options={taskTypes}
                                    onChange={(e) => {
                                        setTaskType(e.value);
                                        setSelectedMembers([]); // Reset members on task type change
                                    }}
                                    placeholder="Select Task Type"
                                    className="w-100 mb-3"
                                />
                            </Col>
                            <Col md={12} lg={6} className="px-2 mb-3 ">
                                <label>Due Date</label>
                                <div className='d-flex gap-2'>
                                <Calendar
                                    value={dueDateOnly}
                                    onChange={(e) => setDueDateOnly(e.value)}
                                    dateFormat="dd/mm/yy"
                                    placeholder="Select due date"
                                    className="w-100"
                                    showIcon
                                />

                                <input
                                    type="time"
                                    className="form-control"
                                    value={dueTimeOnly}
                                    onChange={(e) => setDueTimeOnly(e.target.value)}
                                />
                                </div>
                            </Col>

                            <Col md={12} lg={6} className="px-2 mb-3">
                                <label>Reminder Date</label>
                                <Calendar
                                    value={reminderDate}
                                    onChange={(e) => setReminderDate(e.value)}
                                    showIcon
                                    className="w-100"
                                    dateFormat="dd/mm/yy"
                                />
                            </Col>
                            <Col md={12} lg={6} className="px-2 mb-3">
                                <label>Priority</label>
                                <Dropdown
                                    value={priority}
                                    options={priorities}
                                    onChange={(e) => setPriority(e.value)}
                                    placeholder="Select Priority"
                                    className="w-100 mb-3"
                                />
                            </Col>

                            {taskType === 'Normal' && (
                                <Col md={12} lg={6} className="px-2 mb-3">
                                    <label>Task Members</label>
                                    <MultiSelect
                                        value={selectedMembers}
                                        options={members.map((user) => ({
                                            label: `${user.first_name} ${user.last_name}`,
                                            value: user.user_id,
                                        }))}
                                        onChange={(e) => setSelectedMembers(e.value)}
                                        placeholder="Select team members"
                                        filter
                                        className="w-100 mb-3"
                                        display="chip"
                                    />
                                </Col>
                            )}

                            {(taskType === 'Meeting' || taskType === 'Post') && (
                                <Col md={12} lg={6} className="px-2 mb-3">
                                    <label>Task Member</label>
                                    <MultiSelect
                                        value={selectedMembers}
                                        options={members.map((user) => ({
                                            label: `${user.first_name} ${user.last_name}`,
                                            value: user.user_id,
                                        }))}
                                        onChange={(e) => {
                                            // Allow only one selection
                                            setSelectedMembers(e.value.length > 1 ? [e.value[e.value.length - 1]] : e.value);
                                        }}
                                        placeholder="Select a team member"
                                        className="w-100 mb-3"
                                        display="chip"
                                        maxSelectedLabels={1}
                                    />
                                </Col>
                            )}


                            {taskType === 'Meeting' && (
                                <>
                                    <Col md={12} lg={12} className="px-2 mb-3">
                                        <label>Meeting Details</label>
                                    </Col>
                                    <Col md={6} lg={6} className="mb-3 px-1">
                                        <label>
                                            Meeting Title
                                            <i className='pi pi-info-circle text-warning custom-target-icon ms-2'
                                                data-pr-tooltip="Note: This title will be visible in the minutes of meeting."
                                                data-pr-position="right"
                                                data-pr-at="right+5 top"
                                                data-pr-my="left center-2"
                                            />
                                            <Tooltip target=".custom-target-icon" />
                                        </label>
                                        <InputText name="meeting_title" value={formData.meeting_title} onChange={handleChange} className="w-100" />
                                    </Col>

                                    <Col md={6} lg={3} className="mb-3 px-1">
                                        <label>
                                            Meeting Type
                                            <i className='pi pi-info-circle text-warning custom-target-icon ms-2'
                                                data-pr-tooltip="Note: Nature of the Meeting that has been Completed."
                                                data-pr-position="right"
                                                data-pr-at="right+5 top"
                                                data-pr-my="left center-2"
                                            />
                                            <Tooltip target=".custom-target-icon" />
                                        </label>
                                        <Dropdown
                                            name="meeting_type"
                                            value={formData.meeting_type}
                                            options={meetingTypes}
                                            onChange={handleChange}
                                            placeholder="Select Meeting Type"
                                            className="w-100"
                                        />
                                    </Col>

                                    <Col md={6} lg={3} className="mb-3 px-1">
                                        <label>
                                            Date
                                            <i className='pi pi-info-circle text-warning custom-target-icon ms-2'
                                                data-pr-tooltip="Note: Date the meeting has been conducted."
                                                data-pr-position="right"
                                                data-pr-at="right+5 top"
                                                data-pr-my="left center-2"
                                            />
                                            <Tooltip target=".custom-target-icon" />
                                        </label>
                                        <Calendar name="date" value={formData.date} onChange={handleChange} dateFormat="dd-mm-yy" className="w-100" />
                                    </Col>

                                    <Col md={12} lg={6} className="mb-3 px-1">
                                        <label>
                                            Meeting Members
                                            <i className='pi pi-info-circle text-warning custom-target-icon ms-2'
                                                data-pr-tooltip="Note: Names of Meeting Participants / Attendees (Separated by Commas)."
                                                data-pr-position="right"
                                                data-pr-at="right+5 top"
                                                data-pr-my="left center-2"
                                            />
                                            <Tooltip target=".custom-target-icon" />
                                        </label>
                                        <InputTextarea rows={3} name="meeting_members" value={formData.meeting_members} onChange={handleChange} className="w-100 h-auto" />
                                    </Col>

                                    <Col md={12} lg={6} className="mb-3 px-1">
                                        <label>
                                            Agenda
                                            <i className='pi pi-info-circle text-warning custom-target-icon ms-2'
                                                data-pr-tooltip="Note: Agenda of the Meeting."
                                                data-pr-position="right"
                                                data-pr-at="right+5 top"
                                                data-pr-my="left center-2"
                                            />
                                            <Tooltip target=".custom-target-icon" />
                                        </label>
                                        <InputTextarea rows={3} name="agenda" value={formData.agenda} onChange={handleChange} className="w-100 h-auto" />
                                    </Col>

                                    <Col md={12} lg={6} className="mb-3 px-1">
                                        <label>
                                            Action Items
                                            <i className='pi pi-info-circle text-warning custom-target-icon ms-2'
                                                data-pr-tooltip="Note: Actions that have been discussed in this Meeting."
                                                data-pr-position="right"
                                                data-pr-at="right+5 top"
                                                data-pr-my="left center-2"
                                            />
                                            <Tooltip target=".custom-target-icon" />
                                        </label>
                                        <InputTextarea rows={3} name="action_items" value={formData.action_items} onChange={handleChange} className="w-100 h-auto" />
                                    </Col>

                                    <Col md={12} lg={6} className="mb-3 px-1">
                                        <label>
                                            Discussions
                                            <i className='pi pi-info-circle text-warning custom-target-icon ms-2'
                                                data-pr-tooltip="Note: Elaborate discussions that have been discussed in this Meeting."
                                                data-pr-position="right"
                                                data-pr-at="right+5 top"
                                                data-pr-my="left center-2"
                                            />
                                            <Tooltip target=".custom-target-icon" />
                                        </label>
                                        <InputTextarea rows={3} name="discussions" value={formData.discussions} onChange={handleChange} className="w-100 h-auto" />
                                    </Col>

                                    <Col md={12} lg={6} className="mb-3 px-1">
                                        <label>
                                            Decisions
                                            <i className='pi pi-info-circle text-warning custom-target-icon ms-2'
                                                data-pr-tooltip="Note: Decisions that have been discussed in this Meeting."
                                                data-pr-position="right"
                                                data-pr-at="right+5 top"
                                                data-pr-my="left center-2"
                                            />
                                            <Tooltip target=".custom-target-icon" />
                                        </label>
                                        <InputTextarea rows={3} name="decisions" value={formData.decisions} onChange={handleChange} className="w-100 h-auto" />
                                    </Col>

                                    <Col md={12} lg={6} className="mb-3 px-1">
                                        <label>
                                            Client Updates
                                            <i className='pi pi-info-circle text-warning custom-target-icon ms-2'
                                                data-pr-tooltip="Note: Updates from Clients regarding the Meeting (if any)."
                                                data-pr-position="right"
                                                data-pr-at="right+5 top"
                                                data-pr-my="left center-2"
                                            />
                                            <Tooltip target=".custom-target-icon" />
                                        </label>
                                        <InputTextarea rows={3} name="client_updates" value={formData.client_updates} onChange={handleChange} className="w-100 h-auto" />
                                    </Col>

                                </>
                            )}

                            {taskType === 'Post' && (
                                <>
                                    <Col md={12} lg={12} className="px-2 mb-3">
                                        <label>Post Details</label>
                                    </Col>
                                    <Col md={12} lg={12} className="mb-3 px-1">
                                        <label>
                                            Post Type
                                            <i className='pi pi-info-circle text-warning custom-target-icon ms-2'
                                                data-pr-tooltip="Note: Type Of Post (Carousel, Satic Reel, etc.)."
                                                data-pr-position="right"
                                                data-pr-at="right+5 top"
                                                data-pr-my="left center-2"
                                            />
                                            <Tooltip target=".custom-target-icon" />
                                        </label>
                                        <InputTextarea rows={3} name="post_title" value={formData.post_title} onChange={handleChange} className="w-100" />
                                    </Col>
                                    <Col md={12} lg={6} className="mb-3 px-1">
                                        <label> Post Date
                                            <i className='pi pi-info-circle text-warning custom-target-icon ms-2'
                                                data-pr-tooltip="Note: Updates from Clients regarding the Meeting (if any)."
                                                data-pr-position="right"
                                                data-pr-at="right+5 top"
                                                data-pr-my="left center-2"
                                            />
                                            <Tooltip target=".custom-target-icon" />
                                        </label>
                                        <Calendar name="date" value={formData.date} onChange={handleChange} dateFormat="dd-mm-yy" className="w-100" />
                                    </Col>
                                    <Col md={12} lg={6} className="mb-3 px-1">
                                        <label>
                                            Brand Color
                                            <i className='pi pi-info-circle text-warning custom-target-icon ms-2'
                                                data-pr-tooltip="Note: Choose the brand’s color theme."
                                                data-pr-position="right"
                                                data-pr-at="right+5 top"
                                                data-pr-my="left center-2"
                                            />
                                            <Tooltip target=".custom-target-icon" />
                                        </label>

                                        <div className="d-flex w-100 align-items-center">
                                            {/* Dropdown for selecting color */}
                                            <select
                                                id="color"
                                                className="form-select w-75 me-2"
                                                value={formData.color}
                                                onChange={(e) =>
                                                    setFormData({ ...formData, color: e.target.value })
                                                }
                                            >
                                                <option value="" disabled>Select a color</option>
                                                {colors.map(({ color, name }) => (
                                                    <option key={color} value={color}>
                                                        {name}
                                                    </option>
                                                ))}
                                            </select>

                                            {/* Color preview box */}
                                            {formData.color && (
                                                <div
                                                    className="color-preview-circle"
                                                    style={{
                                                        width: "46px",
                                                        height: "46px",
                                                        backgroundColor: formData.color,
                                                        borderRadius: "5px",
                                                        border: "1px solid #ccc",
                                                    }}
                                                ></div>
                                            )}
                                        </div>
                                    </Col>

                                </>
                            )}


                            <Col md={12} lg={12} className="px-1 text-end d-flex justify-content-end">

                                <Button
                                    onClick={handleSubmit}
                                    label={loading ? "Saving..." : "Save"}
                                    icon="pi pi-save"
                                    className="me-2"
                                    disabled={loading}
                                    severity="success"
                                    outlined
                                />

                                <Button
                                    onClick={onClose}
                                    icon="pi pi-times"
                                    className="p-button-danger"
                                    label='Cancel'
                                    outlined
                                />

                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            </Col>
        </Row >
    );
};

export default Add_task;
